import { atomWithReset, useResetAtom } from 'jotai/utils';

export const hasProfileAtom = atomWithReset<boolean>(false);
export const isOnboardingAtom = atomWithReset<boolean>(true); // true if the user hasn't finished the onboarding yet
export const isInsideOnboardingAtom = atomWithReset<boolean>(false); // true if the user is currently inside the onboarding flow
export const registrationMethodAtom = atomWithReset<string>('email');

// When user register as borrower but has an immature neighbour
// Don't show the latest flow if value is false
export const isRegisterWithImmatureNeighbourAtom = atomWithReset<boolean>(false);

export function useResetProfileAtoms() {
  const resetHasProfile = useResetAtom(hasProfileAtom);
  const resetIsOnboarding = useResetAtom(isOnboardingAtom);
  const resetIsInsideOnboarding = useResetAtom(isInsideOnboardingAtom);
  const resetRegistrationMethodAtom = useResetAtom(registrationMethodAtom);
  const resetIsRegisterWithImmatureNeighbour = useResetAtom(isRegisterWithImmatureNeighbourAtom);
  return () => {
    resetHasProfile();
    resetIsOnboarding();
    resetIsInsideOnboarding();
    resetRegistrationMethodAtom();
    resetIsRegisterWithImmatureNeighbour();
  };
}
